export function isPageVisibilityApiSupported(): boolean {
    return (
        document.hidden !== undefined ||
        document['msHidden'] !== undefined ||
        document['webkitHidden'] !== undefined
    );
}

function getPageVisibilityChangedEventName(): string {
    if (document.hidden !== undefined) {
        return 'visibilitychange';
    } else if (document['msHidden'] !== undefined) {
        return 'msvisibilitychange';
    } else if (document['webkitHidden'] !== undefined) {
        return 'webkitvisibilitychange';
    }

    throw new Error('Page Visibility not supported');
}

export function isPageHidden(): boolean {
    if (document.hidden !== undefined) {
        return document.hidden;
    } else if (document['msHidden'] !== undefined) {
        return document['msHidden'];
    } else if (document['webkitHidden'] !== undefined) {
        return document['webkitHidden'];
    }

    throw new Error('Page Visibility not supported');
}

export function addPageVisibilityChangedEventListener(
    visibilityChangedListener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
): void {
    const pageVisibilityChangedEventName = getPageVisibilityChangedEventName();

    document.addEventListener(pageVisibilityChangedEventName, visibilityChangedListener, options);
}

export function removePageVisibilityChangedEventListener(
    visibilityChangedListener: EventListenerOrEventListenerObject,
    options?: boolean | EventListenerOptions
): void {
    const pageVisibilityChangedEventName = getPageVisibilityChangedEventName();

    document.removeEventListener(
        pageVisibilityChangedEventName,
        visibilityChangedListener,
        options
    );
}
